


























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ButtonWithIcon extends Vue {
  @Prop()
  isLoading: false;

  @Prop({ required: true })
  variant: string;

  @Prop({ default: 'disable' })
  disableVariant: string;

  @Prop()
  isDisable: false;

  @Prop({ required: true })
  icon!: string;

  @Prop({ required: true })
  disableIcon!: string;

  @Prop({ default: '16' })
  iconSize!: string;

  get iconUrl() {
    return require('@/assets/icon/ic_' + this.icon + '.svg');
  }

  get disableIconUrl() {
    return require('@/assets/icon/ic_' + this.disableIcon + '.svg');
  }

  buttonClicked() {
    this.$emit('butttonClick');
  }
}
